import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Divider,
  Card,
  TextField,
  Button,
  Typography,
  CircularProgress,
  colors
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import meansOfAccess from 'constants/meansOfAccess'
import { MultiSelect } from './components';

const useStyles = makeStyles(theme => ({
  root: {},
  textFieldContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  formGroup: {
    flex: 1,
    padding: theme.spacing(2, 2)
  },
  field: {
    marginTop: 0,
    marginBottom: 0
  },
  selects: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    backgroundColor: colors.grey[50],
    padding: theme.spacing(1)
  },
  actions: {
    flexDirection: 'row',
    padding: theme.spacing(3),
    '& > * + *': {
      marginRight: theme.spacing(2),
      marginLeft: theme.spacing(2),
    }
  },
  filtersTitle: {
    padding: theme.spacing(2),
  },
  buttonProgress: {
    color: colors.green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const selects = [
  {
    label: 'Access',
    key: 'access',
    options: meansOfAccess.map((access, index) => ({ id: access.id, label: access.name })),
  },
];

const Filter = props => {
  const { onFilter, isLoading, className, ...rest } = props;

  const classes = useStyles();
  const initialValues = {
    parkingName: '',
    city: '',
    access: '',
  };
  const [values, setValues] = useState({ ...initialValues });

  const handleFieldChange = (event, field, value) => {
    event && event.persist && event.persist();
    setValues(values => ({
      ...values,
      [field]: value
    }));
  };

  const handleSelect = (field, value) => {
    handleFieldChange(null, field, Number(value))
  };

  const handleClear = () => {
    setValues(initialValues)
    handleSubmit()
  }

  const handleSubmit = (event) => {
    event && event.preventDefault();
    if (onFilter) {
      let countItems = 0
      const updatedValues = Object.keys(values).reduce((acc, key) => {
        if (values[key] !== '') {
          countItems++
          return { ...acc, [key]: values[key], }
        }
        return acc
      }, {})
      onFilter(countItems ? updatedValues : null)
    }
  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Typography variant="h4" className={classes.filtersTitle}>Filters</Typography>
      <form onSubmit={handleSubmit}>
        <div className={classes.textFieldContainer}>
          <div className={classes.formGroup}>
            <TextField
              fullWidth
              className={classes.field}
              label="Parking Name"
              margin="dense"
              name="parkingName"
              onChange={event =>
                handleFieldChange(
                  event,
                  'parkingName',
                  event.target.value
                )
              }
              value={values.parkingName}
              variant="outlined"
            />
          </div>
          <div className={classes.formGroup}>
            <TextField
              fullWidth
              className={classes.field}
              label="City"
              margin="dense"
              name="city"
              onChange={event =>
                handleFieldChange(
                  event,
                  'city',
                  event.target.value
                )
              }
              value={values.city}
              variant="outlined"
            />
          </div>
        </div>
        <Divider />
        <div className={classes.selects}>
          <div>
            {selects.map(select => (
              <MultiSelect
                key={select.label}
                label={select.label}
                onChange={(value) => { handleSelect(select.key, value) }}
                options={select.options}
                value={values[select.key]}
              />
            ))}
          </div>
          <div className={classes.actions}>
            <Button
              onClick={handleClear}
              variant="contained"
              disabled={isLoading}
            >
              <DeleteIcon className={classes.buttonIcon} />
              Clear
            </Button>
            <Button
              color="primary"
              type="submit"
              variant="contained"
              disabled={isLoading}
            >
              Apply filters
              {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
            </Button>
          </div>
        </div>
      </form>
    </Card>
  );
};

Filter.propTypes = {
  onFilter: PropTypes.func,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
};

export default Filter;
